import type { EditPageSettings } from '@renderer/types/configState'

/** What the sticker page offers, from the project's Edit settings. */
export interface EditStickerOptions {
  /** The Auto layout toggle is shown, and starts on. */
  autoLayout: boolean
  /** The Draw tab is shown. */
  drawEnabled: boolean
}

/**
 * The Studio's two toggles, with the old sticker mode as the fallback.
 *
 * Projects saved before the toggles carry only `stickerMode`, and must keep
 * what their guests had: the classic editor (null) and Freestyle were
 * placed by hand, Quick and Both laid sets out; only classic had a brush.
 * Mirrors `lib/projects/editStickerOptions.ts` in the Studio — keep the two
 * in step.
 */
export function resolveEditStickerOptions(
  settings?: Pick<EditPageSettings, 'stickerMode' | 'autoLayout' | 'drawEnabled'> | null
): EditStickerOptions {
  const mode = settings?.stickerMode ?? null
  return {
    autoLayout:
      typeof settings?.autoLayout === 'boolean'
        ? settings.autoLayout
        : mode === 'quick' || mode === 'both',
    drawEnabled: typeof settings?.drawEnabled === 'boolean' ? settings.drawEnabled : mode === null
  }
}
